import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HomeMiniIcon(props: IconProps) {
    return <Icon {...props} iconKey={"home_mini"}/>
}
